export enum TrackerFileSourceEventEnum {
    NORMAL = 'Gravação Normal',
    DISTRACTION = 'Distração',
    SMOKING = 'Uso de cigarro',
    PHONE_USE = 'Uso de telefone',
    FRONTAL_COLISION = 'Colisão Frontal',
    LANE_DEPARTURE = 'Saída de faixa',
    FRONTAL_PROXIMITY = 'Proximidade Frontal',
    PEDESTRIAN_MOTORCYCLE_PROXIMITY = 'Proximidade de Pedestre/Motocicleta',
    FREQUENT_LANE_CHANGE = 'Troca de faixa frequente',
    OBSTACLE_PROXIMITY = 'Proximidade de Obstáculo',
    FADING_SLEEP = 'Sono (fadiga)',
    DRIVER_ABSENT = 'Motorista ausente'
}
